import React, { createContext, useState, useContext } from 'react';

export const ProgressContext = createContext();

export const ProgressProvider = ({ children }) => {
  const [progressText, setProgressText] = useState('Disponible');
  const [isLoading, setIsLoading] = useState(false);

  const reloadProgress = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 500); 
  };

  return (
    <ProgressContext.Provider value={{ 
      progressText, 
      setProgressText,
      isLoading,
      reloadProgress
    }}>
      {children}
    </ProgressContext.Provider>
  );
};

export const useProgress = () => {
  const context = useContext(ProgressContext);
  if (!context) {
    throw new Error('useProgress must be used within a ProgressProvider');
  }
  return context;
}; 